import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme, Tooltip, Typography } from '@mui/material';
import BadgeIcon from '../../elements/BadgeIcon/BadgeIcon';
import { SupplyChainConnector } from '../supplychain-types';
import ConnectorsTooltip from '../../elements/ConnectorsTooltip/ConnectorsTooltip';

const SupplyChainConnectorsMore: FC<
  React.PropsWithChildren<SupplyChainMoreConnectorsProps>
> = ({ connectors = [] }) => {
  const { classes } = useStyles();

  return (
    <>
      {connectors.length > 3 && (
        <Tooltip
          placement='top'
          arrow
          title={
            <ul className={classes.list}>
              {connectors
                .slice(3)
                .map(
                  ({
                    name,
                    connectorStatus,
                    displayName,
                    iconURL,
                    status,
                    isBuiltIn,
                  }) => (
                    <li key={name}>
                      <ConnectorsTooltip
                        isBuiltIn={isBuiltIn}
                        displayName={displayName}
                        statusColor={connectorStatus.color}
                        title={connectorStatus.title}>
                        <BadgeIcon
                          overlap='circular'
                          badgeIcon={iconURL}
                          badgeStatus={status}
                          systemByOxBadge={isBuiltIn}
                          marginY={1}
                          innerIconHeight={22}
                        />
                      </ConnectorsTooltip>
                    </li>
                  ),
                )}
            </ul>
          }>
          <Typography color='primary.light' variant='body2' whiteSpace='nowrap'>
            + {connectors.length - 3} more
          </Typography>
        </Tooltip>
      )}
    </>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  list: {
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: 0,
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    '& > li': {
      flex: '0 0 50px',
      textAlign: 'center',
      minWidth: 50,
    },
  },
}));

export interface SupplyChainMoreConnectorsProps {
  connectors?: SupplyChainConnector[];
}

export default SupplyChainConnectorsMore;
